import { useTranslation } from "react-i18next";
import { errorMessage } from "../../../i18n/errors";
import { ApiRequestError } from "../../api/fetcher";
import { Banner } from "./Banner";

/** Renders an API error through errors:CODE with its params in a danger Banner; nothing else is ever shown. */
export function ErrorBanner({ error, action }: { error: unknown; action?: React.ReactNode }) {
  const { t } = useTranslation("errors");
  if (!error) return null;
  const code = error instanceof ApiRequestError ? error.code : "INTERNAL";
  const params = error instanceof ApiRequestError ? error.params : undefined;
  return (
    <Banner tone="danger" action={action}>
      {errorMessage(t, code, params)}
    </Banner>
  );
}
